import { createContext, useContext, useState, useEffect, type ReactNode } from "react";

interface NightModeState {
  isNightMode: boolean;
  toggleNightMode: () => void;
  fontSize: number;
  setFontSize: (size: number) => void;
}

const NightModeContext = createContext<NightModeState | null>(null);

export function NightModeProvider({ children }: { children: ReactNode }) {
  const [isNightMode, setIsNightMode] = useState(() => {
    try {
      return localStorage.getItem("ww-night-mode") === "true";
    } catch {
      return false;
    }
  });

  const [fontSize, setFontSize] = useState(() => {
    try {
      return parseInt(localStorage.getItem("ww-font-size") || "18", 10);
    } catch {
      return 18;
    }
  });

  useEffect(() => {
    localStorage.setItem("ww-night-mode", String(isNightMode));
  }, [isNightMode]);

  useEffect(() => {
    localStorage.setItem("ww-font-size", String(fontSize));
  }, [fontSize]);

  const toggleNightMode = () => setIsNightMode((prev) => !prev);

  return (
    <NightModeContext.Provider value={{ isNightMode, toggleNightMode, fontSize, setFontSize }}>
      {children}
    </NightModeContext.Provider>
  );
}

export function useNightMode() {
  const ctx = useContext(NightModeContext);
  if (!ctx) throw new Error("useNightMode must be used within NightModeProvider");
  return ctx;
}
